import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ReferentielService } from '../../../../core/services/referentiel.service';
import { BannerComponent } from '../../../../shared/components/banner/banner.component';
import { SafeMapsComponent } from '../../../../shared/components/maps/safe-maps.component';
import {
  BuildingIcon,
  LucideAngularModule,
  MailIcon,
  PhoneIcon,
  StethoscopeIcon,
  UserIcon,
  AlertCircleIcon,
} from 'lucide-angular';
import { CardDoctorComponent } from '../../../../shared/components/card-doctor/card-doctor.component';
import { DoctorStructureSlotsComponent } from '../../../../shared/components/doctor-structure-slots/doctor-structure-slots.component';

@Component({
  selector: 'app-medecin-details',
  standalone: true,
  imports: [
    CommonModule,
    BannerComponent,
    SafeMapsComponent,
    DoctorStructureSlotsComponent,
    LucideAngularModule,
  ],
  templateUrl: './medecin-details.component.html',
  styleUrls: ['./medecin-details.component.scss'],
})
export class MedecinDetailsComponent implements OnInit {
  doctor: any;
  loading = true;
  error: string | null = null;

  readonly UserIcon = UserIcon;
  readonly MailIcon = MailIcon;
  readonly PhoneIcon = PhoneIcon;
  readonly BuildingIcon = BuildingIcon;
  readonly StethoscopeIcon = StethoscopeIcon;
  readonly AlertCircleIcon = AlertCircleIcon;

  bannnerLinks: { label: string; href?: string }[] = [];

  constructor(
    private route: ActivatedRoute,
    private referentielService: ReferentielService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'];
      const country = params['country'];

      this.bannnerLinks = [
        { label: 'Portail Public', href: `/${country}/home` },
        { label: 'Médecins', href: `/${country}/medecins` },
        { label: 'Détails', href: undefined },
      ];

      this.loadDoctorDetails(id);
    });
  }
  theSpecs: any[] = [];
  reasons: any[] = [];

  private loadDoctorDetails(id: string): void {
    this.loading = true;
    this.theSpecs = []; // Réinitialiser à chaque chargement
    this.referentielService.getDoctorDetails(id).subscribe({
      next: (doctor) => {
        this.doctor = doctor;
        if (doctor.doctorSpecialisations?.length) {
          doctor.doctorSpecialisations.forEach((element: any) => {
            if (element.specialisation?.name) {
              this.theSpecs.push(element.specialisation.name);
            }
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading doctor details:', error);
        this.error = 'Error loading doctor details';
        this.loading = false;
      },
    });
  }

  get hasPriseDeRdvService(): boolean {
    return !!(
      this.doctor?.doctorServicesAvailable &&
      this.doctor.doctorServicesAvailable.some(
        (service: any) => service?.name === 'Prise de Rdv',
      )
    );
  }
}
